import { unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "me-2"
}
const _hoisted_2 = {
  key: 0,
  class: "pe-0"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column align-items-center col-sm-6"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 3,
  class: "d-flex flex-column align-items-center col-sm-6"
}
const _hoisted_6 = { class: "text-gray-50 d-flex align-items-center" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 4,
  class: "d-flex flex-column align-items-center col-sm-6 me-2"
}
const _hoisted_10 = ["innerHTML"]

import {ref, watch, computed, toRefs} from 'vue';
import {formatDateEnToIT} from '../../filters/common.filters.js'
import {useChecklistStore, usePraticaStore} from "../../store/crm.store";


export default {
  __name: 'ValidazioneDocumenti',
  props: {
  /**
   * stato del questionario al quale sono relazionate le validazioni
   */
  statoDelQuestionario: {
    type: String,
    default: ''
  },
  /**
   * risposta correlata alla validazione
   */
  risposta: {
    type: [Array, Object, File],
    default() {
      return {}
    }
  },
  /**
   * domanda di partenza richiesta
   */
  domanda: {
    type: [Array, Object],
    default() {
      return {}
    }
  }
},
  emits: [
  /**
   * Emitta la scelta del notaio in merito alla validazione
   */
  'gestioneRisposte'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Si occupa di renderizzare gli elementi per la validazione agganciati ai documenti della checklist
 */
const props = __props

const praticaStore = usePraticaStore();
const checklistStore = useChecklistStore();

const emits = __emit;

const rispostaAttiva = ref(null);
const domandaAttiva = ref(null);

const {domanda} = toRefs(props)
const {risposta} = toRefs(props)

watch(risposta, (newValue) => {
  rispostaAttiva.value = newValue;
}, {immediate: true, deep: true})

watch(domanda, (newValue) => {
  domandaAttiva.value = newValue;
}, {immediate: true, deep: true})

/**
 * Gestisce la scelta di validazione fatta dal notaio
 * @param stato
 * @param domanda
 * @param file
 */
const gestioneRisposte = (stato, domanda, file) => {
  emits('gestioneRisposte', stato, domanda, file)
}
// --------------------------------------------------------------------------------------------
// Computed for visibility condition

/**
 * Return true if answer is accepted
 * @type {ComputedRef<boolean>}
 */
const isAccepted = computed(() => {
  return rispostaAttiva.value.is_accettato === 1
})

/**
 * Return true if answer is rejected
 * @type {ComputedRef<boolean>}
 */
const isRejected = computed(() => {
  return rispostaAttiva.value.is_accettato === 0
})

/**
 * Return true if notaio have already validate but not confirmed yet
 * @type {ComputedRef<unknown>}
 */
const isNotaioNotBlocked = computed(() => {
  return (rispostaAttiva.value.is_accettato !== 1 || rispostaAttiva.value.is_accettato !== 0) && praticaStore.tipoUtenteConnesso === 'notaio' && !rispostaAttiva.value.is_blocked
})

/**
 * Return true if answer have validation confirmed and user is cittadino and checklist'state is readonly
 * @type {ComputedRef<boolean>}
 */
const isCittadinoAnswer = computed(() => {
  return (rispostaAttiva.value.is_accettato === null && praticaStore.tipoUtenteConnesso === 'cittadino' && checklistStore.questionarioAttivoStatus === 'readonly')
})

return (_ctx, _cache) => {
  return (isCittadinoAnswer.value || isNotaioNotBlocked.value || isAccepted.value || isRejected.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((__props.statoDelQuestionario === 'readonly' && _unref(praticaStore).tipoUtenteConnesso === 'notaio') || (_unref(praticaStore).tipoUtenteConnesso === 'cittadino'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["row m-0 align-items-center d-flex", {'justify-content-end': (rispostaAttiva.value.is_blocked || rispostaAttiva.value.is_accettato != null)
    || (rispostaAttiva.value.is_accettato === null && rispostaAttiva.value.is_blocked === null),
    'justify-content-between': _unref(praticaStore).tipoUtenteConnesso === 'notaio' && !rispostaAttiva.value.is_blocked}])
              }, [
                _createCommentVNode(" Approva CTA "),
                (rispostaAttiva.value.is_accettato !== 1 && _unref(praticaStore).tipoUtenteConnesso === 'notaio' && !rispostaAttiva.value.is_blocked)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["btn c-pointer col-sm-5 me-1 h-35p mt-4 mt-xl-0", {'btn-outline-dark': rispostaAttiva.value.is_accettato === 0, 'btn-outline-success': rispostaAttiva.value.is_accettato !== 0}]),
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = $event => (gestioneRisposte(1, domandaAttiva.value, rispostaAttiva.value)))
                    }, "Approva ", 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Messaggio se la rispostaAttiva è approvata "),
                (isAccepted.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-success d-flex align-items-center" }, [
                        _createElementVNode("span", { class: "me-1" }, "Approvato"),
                        _createElementVNode("i", { class: "fas fa-check" })
                      ], -1 /* CACHED */)),
                      (rispostaAttiva.value.validazione_notaio_at)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "c-grey mt-1 align-items-center text-center crm:inline-block",
                            innerHTML: _unref(formatDateEnToIT)(rispostaAttiva.value.validazione_notaio_at)
                          }, null, 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Rifiuta CTA "),
                (rispostaAttiva.value.is_accettato !== 0 && _unref(praticaStore).tipoUtenteConnesso === 'notaio' && !rispostaAttiva.value.is_blocked)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: _normalizeClass(["btn c-pointer col-sm-5 ms-1 h-35p me-3 mt-4 mt-xl-0", {'btn-outline-dark': rispostaAttiva.value.is_accettato === 1, 'btn-outline-danger': rispostaAttiva.value.is_accettato !== 1}]),
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = $event => (gestioneRisposte('0', domandaAttiva.value, rispostaAttiva.value)))
                    }, "Rifiuta ", 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Messaggio se la rispostaAttiva è in attesa di approvazione "),
                (rispostaAttiva.value.is_accettato === null && _unref(praticaStore).tipoUtenteConnesso === 'cittadino' && _unref(checklistStore).questionarioAttivoStatus === 'readonly')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, [
                        _createElementVNode("span", {
                          class: "me-1",
                          textContent: _toDisplayString(rispostaAttiva.value.bozza === 1 ? 'Caricato ma non inviato' : 'In attesa di validazione')
                        }, null, 8 /* PROPS */, _hoisted_7)
                      ]),
                      _createElementVNode("span", {
                        class: "c-grey mt-1 align-items-center text-center crm:inline-block",
                        innerHTML: _unref(formatDateEnToIT)(_unref(risposta).data_caricamento)
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Messaggio se la rispostaAttiva è rifiutata "),
                (isRejected.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-danger d-flex align-items-center" }, [
                        _createElementVNode("span", { class: "me-1" }, "Rifiutato"),
                        _createElementVNode("i", { class: "fas fa-times" })
                      ], -1 /* CACHED */)),
                      (rispostaAttiva.value.validazione_notaio_at)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "c-grey mt-1 align-items-center text-center crm:inline-block",
                            innerHTML: _unref(formatDateEnToIT)(rispostaAttiva.value.validazione_notaio_at)
                          }, null, 8 /* PROPS */, _hoisted_10))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

}